import qs from "qs";
// import Vue from "vue";
import { Message } from "element-ui";
//
export default (axios) => ({
  accept: "",
  size: 1024 * 1024 * 20,
  downLoadImgUrl:
    window.baseGate.ApiUrl + `/api/service-file-app/app/file/preview-by-id?id=`,
  /*
   * 获取签名信息
   *  @Note("业务类型,前端和业务放规定")
        @NotBlank(message = "业务类型不能为空")
        private String businessType;
        @Note("存储地址,必须要有，和业务放规定，文件服务暂时不处理")
        @NotBlank(message = "存储地址不能为空")
        private String directory;
     
        callbackVar
   */
  getSignature(signature = {}) {
    signature.callbackVar = signature.callbackVar || null;

    return axios({
      url: "/service-file-app/app/oss/get-sign",
      method: "post",
      interface: 1,
      data: signature,
    });
  },

  /* 
        * 上传文件
        * file 文件
        * config.accept :'.png,.jpg.pdf'  , 允许传入格式
        * config.size : , 允许传入大小 km
        * config.formData 参数
        * config.isPulic: 是否公开
        * config.signature: {
                businessType: "",
        directory: "",
        }  , 签名参数
        * config.success 回调函数
        * config.progress 监听进度
        * 
        * 
*/
  async upload(file, config = {}) {
    let fileArr = [];
    this.size = config.size || this.size;
    this.accept = config.accept || this.accept;
    for (let i in file) {
      if (Object.prototype.toString.call(file[i]) == "[object File]") {
        fileArr.push(file[i]);
      }
    }
    let message = [];
    fileArr.forEach((q) => {
      let type = q.name.substring(q.name.lastIndexOf(".")).toLowerCase();
      if (
        q.size > Number(this.size) ||
        (this.accept && this.accept.indexOf(type) == -1)
      ) {
        message.push(q.name);
      }
    });
    if (message.length > 0) {
      let text = message.join(",");
      Message.error(
        `当前文件上传不符合标准的文件有“${text}”` + "支持" + config.accept
      );
      config.finally && config.finally(text);
      return;
    }
    let signatureConfig = {
      ...config.signature,
      // cannedAcl: config.isPulic ? "public-read" : "private",
      cannedAcl: "public-read",
    };
    let configRes = await this.getSignature(signatureConfig);
    if (configRes && configRes.data && configRes.data.code == 0) {
      let fileSuccess = [];
      let promiseArr = [];
      let configParams = JSON.parse(JSON.stringify(configRes.data.data));
      configParams.isPulic = config.isPulic;
      fileArr.forEach((q) => {
        // 存一个返回数组
        fileSuccess.push({
          progress: 0,
          fileName: q.name,
          status: "pendding",
        });
        // 存一个请求队列
        let that = this;
        promiseArr.push(function (NfileSuccess) {
          return new Promise((reslove, reject) => {
            let fileName = q.name;
            configParams.fileName = fileName;
            configParams.file = q;
            that
              .putObjectFile(configParams, (progressEvent) => {
                config.onUploadProgress &&
                  config.onUploadProgress(progressEvent);
                let index = NfileSuccess.findIndex(
                  (q) => q.fileName == fileName
                );
                let process =
                  ((progressEvent.loaded / progressEvent.total) * 100) | 0;
                let progressText = `下载进度：${process}%`;
                let params = NfileSuccess[index];
                params.progress = process;
                NfileSuccess[index] = {
                  ...params,
                };
                if (process < 100) {
                  config.progress &&
                    config.progress(JSON.parse(JSON.stringify(NfileSuccess)));
                }
              })
              .then((res) => {
                let index = NfileSuccess.findIndex(
                  (q) => q.fileName == fileName
                );
                let params = NfileSuccess[index];
                let resItem = res.data.data;
                if (resItem) {
                  delete resItem.fileName;
                }
                if (res.data.code == 0) {
                  params.progress = 100;
                  params.status = "success";
                  NfileSuccess[index] = {
                    ...params,
                    ...resItem,
                  };
                  fileArr[index] = {
                    ...params,
                    ...resItem,
                  };
                } else {
                  fileArr[index].progress = 100;
                  fileArr[index].status = "error";
                }
                config.progress &&
                  config.progress(JSON.parse(JSON.stringify(NfileSuccess)));
                reslove({
                  ...params,
                  ...resItem,
                });
              })
              .catch((e) => {
                reject(e);
              });
          });
        });
      });

      Promise.all(promiseArr.map((q) => q(fileSuccess)))
        .then((res) => {
          config.success && config.success(fileArr);
        })
        .catch((e) => {
          Message.error(e);

          config.catch && config.catch(e);
        })
        .finally((res) => {
          config.finally && config.finally(res);
        });
    }
  },

  /*截至60 文件名称*/
  getSubstringName(name) {
    if (name.length > 60) {
      let type = name.substring(name.lastIndexOf(".")).toLowerCase();
      let divNum = name.length - 60;
      let nameStr = name.substring(0, name.lastIndexOf(".") - divNum);
      return nameStr + type;
    }
    return name;
  },

  /* 简单上传 */
  async putObjectFile(config = {}, fn) {
    config.formData = config.formData || {};
    config.fileName = this.getSubstringName(config.fileName);
    let new_multipart_params = {
      // 文件名字
      name: config.fileName,
      key: config.dir + config.fileName,
      policy: config.policy,
      OSSAccessKeyId: config.accessid,
      success_action_status: 200,
      signature: config.signature,
      callback: config.callback,
      file: config.file,
      ...config.formData,
    };
    let host = config.host;
    let formData = new FormData();
    for (let key in new_multipart_params) {
      formData.append(key, new_multipart_params[key]);
    }
    return axios({
      method: "post",
      url: host,
      interface: 1,
      onUploadProgress: function (progressEvent) {
        fn && fn(progressEvent);
      },
      data: formData,
      headers: {
        // "x-oss-object-acl": config.isPulic ? "public-read" : "private",
        "x-oss-object-acl": "public-read",
      },
    });
  },
});
